var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnitedarabemirates(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.638916,
    y: 0.0361328,
    width: 48.0975,
    height: 48.0975,
    fill: "url(#pattern0_185_773)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_185_773",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_185_773",
    transform: "scale(0.0078125)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_185_773",
    width: 128,
    height: 128,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAYAAADDPmHLAAAACXBIWXMAAAOwAAADsAEnxA+tAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAwpJREFUeJzt3c2Km2UYh/HreewXtbXCiOPOpQO2uFAX3YtQ64gtDthm4wmIIiJ+bEJbXIkt9BDEIgZnbHUo055BxYWU6pyBH0xLOzoVjOZ20Y6oVN007xNzX79VeHkhf8iVhLwkBCRJkiRJkiRJkiRJkiRJkiT9v5U7HYynFvawIw5DOUjwCIUHCbZ2Pe7GrpuXj7+4vK/r+50SQ+AHgtUoLA+3s3j6Gdb/ftJfAoh+v3Lp61co8Q4w09XSf7K+8+cvjx39/PHWO6bEVeD47q843e8z2jxYN2/EwsIuvriyRIn3mYAHX3fdDHDqx8f45PUV7t08WOH2M3+DM8BzrdapM8/HTQYLH3MPbL4CXLryBoX5prPUpQMPb+E1gBrzRx6g8GbrRepWFN5+a5GZSvzaA/a0HqTO3T8sHKkEz7ZeojZGMF+BudZD1MxcBWZbr1AbBR6q0P0VPk2MbfW/z9E0M4DkDCA5A0jOAJIzgOQMIDkDSM4AkjOA5AwgOQNIzgCSM4DkDCA5A0jOAJLb0nrAv9m9dTaOPb0xbL1jmk10AKUW8CtrY+VbQHIGkJwBJGcAyRlAcgaQnAEkZwDJGUByBpCcASRnAMkZQHIGkJwBJGcAyRlAcgaQnAEkZwDJGUByBpCcASRnAMkZQHIT/cugGAXc+vszjclEB3Dt+no5euglfxo2Rr4FJGcAyRlAcgaQnAEkZwDJGUByBpCcASRnAMkZQHIGkJwBJGcAyRlAcgaQnAEkV/ErV5n9Ugm+a71CbUTwbaWw2nqI2qiV1QrxWeshaiMizlW2/XYGuNF6jDp3vZTyUS1LS1cp8W7rNepWKXFiZWVw7dbHwCf2vgecaztJHTq7f//ek3D7OkDp90fspAecbTpLYxfBIuzo9fv9EfzpQlAZDH7iyUcPU3gVWGu2UGNRCmul8PLFi4MXLlz4YOOP43c6OQ707qMODwEHIeYozBLd/3vXGlzuDdnX9f1OiSHwfUR8UyvLtW7/9Pz5D9dbj5IkSZIkSZIkSZIkSZIkSZJ0t/0OMKSTcFcxEWIAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnitedarabemirates);
export default __webpack_public_path__ + "static/media/Unitedarabemirates.bb27a95d527666e5b91ef367f0ca26da.svg";
export { ForwardRef as ReactComponent };